export enum ApplicationMode {
  Live = 'Live',
  Training = 'Training'
}
